import React from 'react';

import Image from '../../elements/Image';
import Button from '../../elements/Button';

function FeatureItem(props) {
    const { title, img, description, position, link, locale } = props;
    const value = locale === '' ? 'Find out more' : 'En savoir plus';

    return (
        <div
            className={`feature-item col-md-6 ${
                position % 2 == 0 ? 'pe-md-4 ps-md-0' : 'ps-md-4 pe-md-0'
            }`}
        >
            <div className="feature-item-bg-wrapper row g-0">
                <div className=" col-2 g-0 justify-content-center align-items-md-center">
                    <Image className="feature-icon" src={img} alt={title} />
                </div>

                <div className="text col-10 ps-2 row g-0">
                    <h5 className="text-highlight col-12">{title}</h5>
                    <p className="sub-segment-text col-12">{description}</p>
                    <Button
                        className="col-12"
                        src={link}
                        value={value}
                        option="transparent"
                    />
                </div>
            </div>
        </div>
    );
}

export default FeatureItem;
